export const UNLIMITED_TOTAL_BUDGET_SUM = 0;
export const API_UNLIMITED_TOTAL_BUDGET_SUM = null;
export const API_UNLIMITED_MAX_DELIVERY_DISTANCE = null;
